module.exports = __webpack_public_path__ + "static/media/medical q icon (active).771ce7b6.svg";